import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';

@Component({
  selector: 'app-addvendor',
  templateUrl: './addvendor.component.html',
  styleUrls: ['./addvendor.component.css']
})
export class AddvendorComponent implements OnInit {
//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

//Save Validation
submitted:boolean;
successfully:boolean;


//Edit Get Values
vendorColl:any=[];
vendorid:number=0

vendorform=new FormGroup({
  vendorcode:new FormControl('',Validators.required),         
  vendorname:new FormControl('',Validators.required),         
  vendorid:new FormControl(0),      
 inactive:new FormControl(false),     
});

isloading:boolean=false;
isprivilage:boolean=false;  
showProgress:boolean=false;
formname:String="Vendor";

constructor(private appService: DhukanDataService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService,private loginService:LoginDataService) { 
     this.route.queryParams.subscribe(params => {
       if(params.id!==undefined){
        this.vendorid = params.id
      }    
     });
     this.fnServiceChanges();

}


fnServiceChanges(){
  this.loginService.serviceloginChange.subscribe((value) => {
        if(this.loginService.fnCheckUser()){
         
          if(this.fnCheckUserPririvilage()){
            this.isloading=true;
            this.fnOnInitForm();
          }
          else{
            this.fnUserFailedForm();
          }
            
        }
        else{
          this.fnUserFailedForm();
        }
  });
}

ngOnInit() {
    try{
      if(this.loginService.fnCheckUser()){ 
        if(this.fnCheckUserPririvilage()){       
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }
      }
      else{
        this.loginService.fnGetUserRoleList();
      }
              
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
}

fnOnInitForm(){

   try{
       this.isaddmode=true;
       this.vendorform.reset();
       this.fnInitializeVendorFormGroup(); 

       if(this.vendorid>0){
         this.fngetVendor();
       }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}



fnCheckUserPririvilage(){
  var _check:boolean=false;
  if (this.vendorid>0){
    _check= this.loginService.fnCheckUserRoleAction(this.formname,'ALTER')
  }else{
    _check= this.loginService.fnCheckUserRoleAction(this.formname,'CREATE')
  }

  return _check;
}

fnUserFailedForm(){
  this.isprivilage=true;
}

fnInitializeVendorFormGroup(){
   this.vendorform.setValue({
      vendorcode:'',
      vendorname:'',
      vendorid:0,      
     inactive:false,      
   })
}

//Get 
fngetVendor() {        
     var data = {
       'vendorid':this.vendorid,            
     }
     this.appService.getVendor(data)
     .subscribe(
       (res)=>{                         
         this.vendorColl=res.json().result;
         var editdata = {
           'vendorid':this.vendorColl[0].vendorid,
           'vendorcode':this.vendorColl[0].vendorcode, 
           'vendorname':this.vendorColl[0].vendorname, 
           'inactive':this.vendorColl[0].inactive,          
         }
         this.fnEditMode(editdata);
     },
     (err)=>{          
       this.toastr.error('Error', err);
     })
}

//Save Btn Click
fnSaveBtnClick(){
   try{
     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.vendorform.valid){
         //Check
         var data = {
               'vendorid': this.vendorid,       
               'vendorcode':this.vendorform.get('vendorcode').value,            
               'vendorname':this.vendorform.get('vendorname').value,
               'inactive': 0,  
               'createdby': this.loginService.fnGetModUserId(),    
               'modifiedby':this.loginService.fnGetModUserId(), 
         }
         this.appService.fnCheckVendor(data).subscribe(
           (res)=>{
             
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.vendorform.get('vendorid').value>0){
                       //Update Department
                       this.fnSetVendor(data);
                     }
                     else{
                       //Insert Department
                       this.fnInsertVendor(data);
                     }
               }
               else{        
                     if(_checkresult==="code"){
                       this.vendorform.controls['vendorcode'].setErrors({'notfound': true});
                     }
               }
         },
         (err)=>{
             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertVendor(data){    
 
   this.appService.fnInsertVendor(data).subscribe(
     (res)=>{
     if(res.json().result!=""){
       this.toastr.success('', "The new vendor has been added successfully.Insert Successfully");

       this.fnInsertActivityLog('INSERT',0,data.vendorname);

       this.fnCloseVendor();
     }},
     (err)=>{
       this.toastr.error('Error', err);
     });

}

//Set
fnSetVendor(data){    

this.appService.fnSetVendor(data).subscribe(
 (res)=>{
 if(res.json().result!=""){
     this.toastr.success('', "The vendor has been updated successfully.");


      this.fnInsertActivityLog('EDIT',this.vendorid,data.vendorname);

     this.fnCloseVendor();        
 }},
 (err)=>{
   this.toastr.error('Error', err);
 });

}

//Close
fnCloseVendor(){
try{
  this.router.navigate(['/Vendor']);
}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
 this.vendorform.setValue({
    vendorcode:deptBO.vendorcode,
    vendorname:deptBO.vendorname,
    vendorid:deptBO.vendorid,
   inactive:deptBO.inactive,   
 });

this.isaddmode=false;
this.iseditmode=true;
this.isdeletemode=false;
this.isviewmode=false;
}

fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}


private fnShowProgress(){
  this.showProgress=true;
}
private fnHideProgress(){
  this.showProgress=false;
}


private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}



}
